module.exports = "<base-card>\r\n  <div #gmap class=\"mdl-card--expand map__window\"></div>\r\n</base-card>\r\n"